// import React from 'react';
// import { useLanguage } from '../context/LanguageContext';
// import { Building2, Scan, HeartPulse, CheckCircle2 } from 'lucide-react';

// const FacilitiesSection = () => {
//   const { t } = useLanguage();

//   const facilities = [
//     {
//       icon: Building2,
//       title: t('facility1_title'),
//       desc: t('facility1_desc'),
//       features: ['Modular OT', 'HEPA Filters', '24/7 Care'],
//     },
//     {
//       icon: Scan,
//       title: t('facility2_title'),
//       desc: t('facility2_desc'),
//       features: ['CT Scan', 'USG', 'Pathology Lab'],
//     },
//     {
//       icon: HeartPulse,
//       title: t('facility3_title'),
//       desc: t('facility3_desc'),
//       features: ['HEPA Filtration', 'Expert Nursing', 'Monitoring'],
//     },
//   ];

//   return (
//     <section
//       id="facilities"
//       className="section-padding bg-slate-900 text-white"
//       data-testid="facilities-section"
//     >
//       <div className="section-container">
//         {/* Section Header */}
//         <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
//           <span className="text-teal-400 font-semibold text-sm uppercase tracking-wider">
//             {t('facilities_subtitle')}
//           </span>
//           <h2
//             className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-2"
//             data-testid="facilities-title"
//           >
//             {t('facilities_title')}
//           </h2>
//         </div>

//         {/* Facilities Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
//           {facilities.map((facility, index) => (
//             <div
//               key={index}
//               className="bg-slate-800/50 rounded-2xl p-6 md:p-8 border border-slate-700 hover:border-teal-500 transition-all duration-300"
//               data-testid={`facility-card-${index + 1}`}
//             >
//               <div className="w-14 h-14 bg-teal-500/20 rounded-xl flex items-center justify-center mb-5">
//                 <facility.icon className="w-7 h-7 text-teal-400" />
//               </div>
//               <h3 className="text-xl font-bold text-white mb-3">{facility.title}</h3>
//               <p className="text-slate-400 mb-5 leading-relaxed">{facility.desc}</p>
              
//               {/* Features */}
//               <ul className="space-y-2">
//                 {facility.features.map((feature, idx) => (
//                   <li key={idx} className="flex items-center gap-2 text-slate-300">
//                     <CheckCircle2 className="w-4 h-4 text-teal-400 flex-shrink-0" />
//                     <span className="text-sm">{feature}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FacilitiesSection;














import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Building2, Scan, HeartPulse, CheckCircle2 } from 'lucide-react';

const FacilitiesSection = () => {
  const { t } = useLanguage();

  const facilities = [
    {
      icon: Building2,
      title: t('facility1_title'),
      desc: t('facility1_desc'),
      features: ['Modular OT', 'HEPA Filters', '24/7 Care'],
    },
    {
      icon: Scan,
      title: t('facility2_title'),
      desc: t('facility2_desc'),
      features: ['CT Scan', 'USG', 'Pathology Lab'],
    },
    {
      icon: HeartPulse,
      title: t('facility3_title'),
      desc: t('facility3_desc'),
      features: ['HEPA Filtration', 'Expert Nursing', 'Monitoring'],
    },
  ];

  return (
    <section
      id="facilities"
      className="py-20 bg-white text-gray-900"
      data-testid="facilities-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#800000] font-semibold text-sm uppercase tracking-wide">
            {t('facilities_subtitle')}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold  p-2">
            {t('facilities_title')}
          </h2>
        </div>

        {/* Facilities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-2xl border border-[#800000]/20 p-8 hover:shadow-2xl transition duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-[#800000]/10 mb-5">
                <facility.icon className="w-8 h-8 text-[#800000]" />
              </div>

              <h3 className="text-xl font-bold text-[#800000] mb-3">{facility.title}</h3>
              <p className=" mb-5 leading-relaxed">{facility.desc}</p>

              <ul className="space-y-2">
                {facility.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3 text-[#4d0000]">
                    <CheckCircle2 className="w-5 h-5 text-[#800000] flex-shrink-0" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FacilitiesSection;